/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  // MutableRefObject,
  useEffect,
  // useRef,
} from 'react';

import './animation010.less';
// import { usePlayFlag } from './../../components/topicScroll';
import useIntersectionObserver from '../../../../../hooks/useIntersectionObserver';

interface IAnimation010Item {
  icon: string;
  color: string;
  text: string;
}

interface IAnimation010Props {
  items: IAnimation010Item[];
  onCompleted: () => void;
}

const Animation010: FunctionComponent<IAnimation010Props> = ({
  items,
  onCompleted,
}) => {
  // const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  // const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.5, // 元素 30% 进入视口时触发
    rootMargin: '-50px', // 根边距缩小 50px（需元素进入视口 50px 后才判定）
  });
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation010 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (isVisible) {
      startPlay();
    }
  }, [isVisible]);
  return (
    <div
      ref={targetRef}
      className="animation010 component"
      style={{ margin: 0 }}
    >
      <div className="animation010-content">
        {items.map((itm: IAnimation010Item, idx: number) => (
          <div
            key={idx}
            className={`animation010-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            style={{
              width: `${(1 / items.length) * 100}%`,
              color: itm.color,
            }}
          >
            <div
              className="animation010-indicate"
              style={{ backgroundColor: itm.color }}
            >
              <div className="animation010-indicate-number">0{idx + 1}</div>
              <div
                className="animation010-icon"
                style={{ borderColor: itm.color }}
              >
                <img src={getImg(itm.icon)} alt="" />
              </div>
            </div>
            <div
              className="animation010-text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation010;
